import {useSuspenseQuery} from '@tanstack/react-query';
import {severityScaleSchema} from 'shared';

import {api} from '@/lib/ky';

import {severityScaleKeys} from './queryKeys';

import type {
  QueryConfig,
  ExtractFnReturnType,
  QueryConfig2,
} from '@/lib/react-query';

export const getSeverityScaleByAsset = async (id: string) => {
  const data = await api.get(`assets/${id}/severity`).json();
  return severityScaleSchema.parse(data);
};

export const useSeverityScaleByAsset = (
  id: string,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: severityScaleKeys.detail(id),
    queryFn: () => getSeverityScaleByAsset(id),
  });
};
export const useSeverityScaleByAssetLoader = (
  config: QueryConfig2<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getSeverityScaleByAsset;
